export enum ELocalStatus {
    Undefined = 0,
    Available = 10,
    Booked = 20,
    Occupied = 30,
    ToDisinfect = 40,
    OverdueForDisinfection = 50,
    Unavailable = 60,
}
